import { ArrowRight } from "lucide-react";

const CheckupHero = () => {
  const scrollToForm = () => {
    document.getElementById("checkup-form")?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToHow = () => {
    document.getElementById("how-it-works")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative bg-hero-bg overflow-hidden">
      <div className="relative z-10 max-w-4xl mx-auto section-padding pt-24 pb-14 md:pt-32 md:pb-18">
        <div className="text-center">
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-accent mb-5 reveal-up">
            For established dental practices that want clearer growth decisions
          </p>

          <h1 className="text-3xl md:text-5xl lg:text-[3.25rem] font-bold text-hero-foreground leading-[1.1] tracking-tight mb-5 reveal-up-delay-1">
            Get a New Patient Growth Checkup<br className="hidden md:block" /> for Your Practice
          </h1>

          <p className="text-base md:text-lg text-hero-foreground/60 max-w-2xl mx-auto mb-4 leading-relaxed reveal-up-delay-1">
            We review your website, Google presence, and new-patient pipeline to show where your practice is losing opportunities — and what to fix first.
          </p>

          <p className="text-sm text-hero-foreground/40 max-w-xl mx-auto mb-8 reveal-up-delay-2">
            Built from 20+ years of dental marketing experience, real practice-side execution, and coordinated online plus offline systems.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 reveal-up-delay-2">
            <button
              onClick={scrollToForm}
              className="inline-flex items-center justify-center gap-2 bg-accent text-accent-foreground px-8 py-4 rounded-lg text-base font-semibold hover:bg-accent/90 transition-all active:scale-[0.97] shadow-lg shadow-accent/25"
            >
              Request My Growth Checkup
              <ArrowRight className="w-4 h-4" />
            </button>
            <button
              onClick={scrollToHow}
              className="inline-flex items-center justify-center gap-2 text-hero-foreground/60 hover:text-hero-foreground px-6 py-4 rounded-lg text-sm font-medium transition-colors"
            >
              See How It Works
            </button>
          </div>

          {/* Trust strip */}
          <p className="text-hero-foreground/30 text-xs mt-8 reveal-up-delay-2">
            Dental-focused marketing experience · Hundreds of practices supported · Websites, ads, direct mail & tracking built to work together
          </p>
        </div>
      </div>
    </section>
  );
};

export default CheckupHero;
